'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = function styles() {
  return {
    message: {
      textAlign: 'center',
      marginBottom: '30px'
    },
    logoImage: {
      maxHeight: '50px',
      maxWidth: '300px',
      margin: '0',
      padding: '0'
    }
  };
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/Footer/BasicFooter/styles.js
// module id = 631
// module chunks = 61549186969478 79611799117203